import React from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import Container from "components/container";
import ReactGA from "react-ga4";
import axios from "axios";

const measurementId = process.env.REACT_APP_GA4_MEASUREMENT_ID;

if (measurementId) {
	ReactGA.initialize(measurementId);
	ReactGA.send({
		hitType: "pageview",
		page:
			typeof window !== "undefined"
				? `${window.location.pathname}${window.location.search}`
				: "/"
	});
}

axios.defaults.baseURL = process.env.REACT_APP_API;

function App() {
	return (
		<Router>
			<Route path="/" exact component={Container} />
		</Router>
	);
}

export default App;
